import React from 'react'
import PrintStyle from '../../styles/PrintStyle'

class Wydruk extends React.Component {
  componentDidMount() {
    const inputs = window.document.querySelectorAll('input')
    inputs.forEach(input => {
      input.disabled = true
    })
    const textareas = window.document.querySelectorAll('textarea')
    textareas.forEach(textarea => {
      textarea.disabled = true
    })
  }

  render() {
    return <PrintStyle>{this.props.children}</PrintStyle>
  }
}

export default Wydruk
